import script from "./CreateContractForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateContractForm.vue?vue&type=script&setup=true&lang=js"

import "./CreateContractForm.vue?vue&type=style&index=0&id=44b454ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44b454ba"]])

export default __exports__